module.exports = __webpack_public_path__ + "85fcadb305655e641995ec109dd6ef72.svg";